import Cookies from 'js-cookie'
const app = {
  state: {
    language: Cookies.get('language') || 'zh'
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_VISITTYPE: (state, visittype) => {
      let vArray = visittype.split(',')
      state.visitType = vArray
      Cookies.set('visitType', vArray)
    },
    SET_NAIRE: (state, naire) => {
      sessionStorage.setItem('naire', JSON.stringify(naire))
    },
    SET_QUESTION: (state, question) => {
      sessionStorage.setItem('question', JSON.stringify(question))
    }
  },
  actions: {
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setVisittype ({ commit }, visittype) {
      commit('SET_VISITTYPE', visittype)
    },
    setQuestionnaire({ commit }, naire) {
      commit('SET_NAIRE', naire)
    },
    setQuestion({ commit }, question) {
      commit('SET_QUESTION', question)
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js